import {dollarsPrettifier} from './dollarsPrettifier'

export const dollarsAbbreviationUnits: Array<[string, number]> = [
  ['Quint.', 1_000_000_000_000_000_000],
  ['Quad.', 1_000_000_000_000_000],
  ['T', 1_000_000_000_000],
  ['B', 1_000_000_000],
  ['M', 1_000_000],
  ['K', 1_000],
]

export type DollarsAbbreviatorOptions = {
  neverShowCents: boolean
  withDollarSign: boolean
  withDecimals: number | false
}

// Taken from `mercury-web`'s implementation: https://github.com/MercuryTechnologies/mercury-web/blob/e9919542f126aa3af1477b8806f3d974cad8f7a1/src/utils/index.ts#L195-L243
export const dollarsAbbreviator = (
  dollars: number | undefined,
  options: DollarsAbbreviatorOptions
): string => {
  // 0 is false so watch out!
  if (dollars !== 0 && !dollars) {
    return ''
  }

  const absDollars = Math.abs(dollars)
  // In order to calculate the correct abbreviation unit, we need to round
  // up the amount to the 3rd significant digit place (since every interval of abbreviation units has 3 digits of precision)
  // on between each abbreviation unit, and then use that to infer how we should abbreviate.
  // This rounding will mitigate problems like we saw here, where 999,900.00 was visualized
  // as $1,000K instead of $1M.
  const roundedDollars = parseFloat(absDollars.toPrecision(3))

  const abbrUnit: [string, number] | undefined = dollarsAbbreviationUnits.find(
    ([_, amt]) => amt <= roundedDollars
  )

  if (abbrUnit) {
    if (options.withDecimals && options.withDecimals > 0) {
      const decimals = 10 ** options.withDecimals
      return `${dollars < 0 ? '-' : ''}${options.withDollarSign ? '$' : ''}${
        Math.round((absDollars / abbrUnit[1]) * decimals) / decimals
      }${abbrUnit[0]}`
    }
    return (
      dollarsPrettifier(dollars / abbrUnit[1], options.withDollarSign, 0) +
      abbrUnit[0]
    )
  } else if (absDollars >= 1000) {
    return dollarsPrettifier(dollars, options.withDollarSign, 0)
  } else {
    return dollarsPrettifier(
      dollars,
      options.withDollarSign,
      options.neverShowCents ? 0 : 2
    )
  }
}
